module.exports = __webpack_public_path__ + "img/noah_igbinoghene.89d5b7eb.png";